import { Tooltip } from "radix-ui";
import type { ComponentProps } from "react";

import { cn } from "@/shared/lib";

export const TooltipContent = ({
  className,
  sideOffset = 4,
  children,
  ...props
}: ComponentProps<typeof Tooltip.Content>) => (
  <Tooltip.Portal>
    <Tooltip.Content
      data-slot="tooltip-content"
      sideOffset={sideOffset}
      className={cn(
        "z-50 w-fit max-w-xs animate-in rounded-md border border-border bg-surface-raised px-3 py-1.5 text-xs text-foreground fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95",
        className,
      )}
      {...props}
    >
      {children}
    </Tooltip.Content>
  </Tooltip.Portal>
);
